<section id="wrapper" class="login-register login-sidebar"
    style="background-image:url(assets/images/login/img_login.svg)">
    <div class="login-box card" style="border-radius: 0 !important;">
        <div class="card-body center-card">
            <form class="form-horizontal form-material full" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <a href="javascript:void(0)" class="text-center db">
                    <img style="margin-bottom: 10px"
                        src="https://gaspre-app.s3.us-east-2.amazonaws.com/assets/images/password/logo-v.png"
                        width="40%" alt="Home" />
                </a>

                <h2 class="welcome">Bienvenido</h2>

                <div class="form-group row">
                    <div class="col-md-6 offset-md-3">
                        <label for="user" style="display: none;"></label>
                        <input class="form-control" id="user" type="text" name="user" placeholder="Usuario"
                            formControlName="user" #user>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-md-6 offset-md-3">
                        <label for="pwd" style="display: none;"></label>
                        <input class="form-control" id="pwd" type="password" name="pwd" placeholder="Contraseña"
                            formControlName="password" #password>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-md-4 offset-md-4">
                        <button class="btn btn-info btn-red btn-lg btn-block btn-rounded" color="primary" type="submit"
                            value="submit" [disabled]="!loginForm.valid">
                            Iniciar Sesión
                        </button>
                    </div>
                </div>

            </form>
        </div>
    </div>
</section>